import React from 'react';
import { AfterSubmitFunc, FormTemplate } from 'ui-builder';
import {
  CreateContractTemplateRequest,
  FileType, ProjectType,
  useContractTemplateAdminService
} from 'nekst-api';
import { FileUploaderInput } from 'features/nekst-widgets';
import { useProjectTypeHelper } from 'features/tasks-forms';

export function CreateContractTemplateForm(
  props: {
    setupAreaId: number,
    setupAreaVersion: string,
    projectType: ProjectType,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {

  const contractTemplateService = useContractTemplateAdminService();

  const projectTypeHelper = useProjectTypeHelper();

  return (
    <FormTemplate<CreateContractTemplateRequest>
      title={`Upload Contract Template (${projectTypeHelper.getLabel(props.projectType)})`}
      submitFormFunc={async (data) => {

        await contractTemplateService.createContractTemplate(
          props.setupAreaId,
          props.setupAreaVersion,
          data
        );

        return data;
      }}
      initialData={{
        projectType: props.projectType
      }}
      validationSchema={{
        fileId: {
          type: 'int',
          constraints: {
            required: true,
          }
        },
        validationFileId: {
          type: 'int',
          constraints: {
            required: true,
          }
        }
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <FileUploaderInput
        fileType={FileType.PROJECT_DOCUMENT}
        fileDataSource="_contractDocumentExampleFile"
        source="fileId"
        label="Contract Document Example File"
        hint="A contract document example is utilized for training AI systems to comprehend the content and structure of contractual agreements."
        asAdmin
      />
      <FileUploaderInput
        fileType={FileType.PROJECT_DOCUMENT}
        fileDataSource="_contractDocumentValidationFile"
        source="validationFileId"
        label="Contract Document Validation File"
        hint="A contract document validation file is utilized for training AI systems to validate the AI training configuration."
        asAdmin
      />
    </FormTemplate>
  );
}
